// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3bCrX","inputWrap":"styles_inputWrap__2m7TY","input":"styles_input__2utcH"};